export interface IFiltering {
	initGrid: (grid: FilteringGridWrapper) => void,
	setFilterId: (filterData: string) => void,
	setChanging: (changing: boolean) => void,
}

export default class FilterManager {
	constructor(filtering: IFiltering) {
		this.filtering = filtering;
	}

	filtering: IFiltering;
	grid: any;

	init(grid: any) {
		this.grid = grid;
		this.filtering.initGrid(new FilteringGridWrapper(grid));
	}

	fnLoadFilter = function (filterData) {
		if (!filterData)
			return;

		this.filtering.setFilterId(filterData);
	}

	fnLoadNewFilter = function (filterId) {
		if (!this.grid || !filterId || this.grid.fnSettings().sFilterId === filterId)
			return;
		this.fnLoadFilter(filterId);
	}

	fnEditFilter = function () {
		this.filtering.setChanging(true);
	}
}

export class FilteringGridWrapper {
	constructor(grid) {
		this.grid = grid;
	}
	grid: any;

	fnDraw() {
		this.grid.fnDraw();
	}

	getFilterId(): string {
		return this.grid.fnSettings().sFilterId;
	}

	getFilterTypeName(): string {
		return this.grid.fnSettings().sFilterTypeName
	}

	getSetting(key: string): any {
		return this.grid.fnSettings()[key];
	}

	setSetting(key: string, value: any) {
		this.grid.fnSettings()[key] = value;
	}

	createFilter(name, isPrivate, kind) {
		var settings = (window as any).$.extend(true, {}, this.grid.fnSettings());
		
		settings.sFilterName = name;
		settings.sFilterPrivacy = isPrivate;
		settings.sFilterKind = kind;

		settings.bIsFilterRequest = true;
		settings.sFilterSave = "/Filters/CreateFilter";

		this.grid.oApi._fnAjaxUpdate(settings);
	}

	filterUpdate(id, name, isPrivate, kind) {

		var settings = (window as any).$.extend(true, {}, this.grid.fnSettings());

		settings.sFilterId = id;
		settings.sFilterName = name;
		settings.sFilterPrivacy = isPrivate;
		settings.sFilterKind = kind;

		settings.bIsFilterRequest = true;
		settings.sFilterSave = "/Filters/UpdateFull/";

		this.grid.oApi._fnAjaxUpdate(settings);
	}
}